import { horizontalEllipsis } from '@ipfabric/frontend-shared-assets/utils/characters';

export const genericMessages = {
  en: {
    components: {
      diff: {
        styleLabel: 'Style',
        noChanges: 'There are no changes.',
        styles: {
          sideBySide: 'Side by side',
          inline: 'Inline',
          inlineDiff: 'Inline diff',
        },
      },
      loadError: {
        text: 'Failed to load data.',
      },
      relatedDeviceList: {
        more: '+ {number} more',
      },
      toggle: {
        on: 'On',
        off: 'Off',
      },
      multiSelect: {
        selected: 'selected',
      },
      select: {
        placeholder: `Select${horizontalEllipsis}`,
        noOptions: 'No options',
        loading: 'Loading options',
      },
      multiTextInput: {
        clear: 'Clear all',
        copyToClipboard: 'Copy to clipboard',
        copied: 'Copied',
      },
      typeahead: {
        typeToSearch: 'Type to search',
        noResults: 'No results found',
      },
      cidr: {
        addLabel: 'Add site',
        addFromPreset: 'Add site from preset',
        selectLabel: 'IP Address / CIDR ',
        searchPlaceholder: 'Search site name or IP/CIDR',
        showingFiltered: (count: number): string =>
          `Filter is active, showing ${count} results.`,
        showingFiltereItems: 'Showing items based on your search filter.',
        showAllItems: (count: number): string => `Show all ${count} items`,
        removeSite: 'Remove site',
        deleteConfirm: {
          header: 'Site will be deleted',
          subHeader:
            ' Are you sure you want to delete site with all its content?',
          btnConfirm: 'Delete',
          btnSecondaryConfirm: 'Cancel',
        },
        multiTextInputPlaceholder: 'Add IP/CIDR',
      },
      treePicker: {
        searchPlaceholder: 'Search...',
        available: 'Available',
        selected: 'Selected',
      },
      facetedFilter: {
        addAttribute: 'Add attribute',
        select: 'Select',
        selectAttribute: 'Select attribute',
        search: 'Search',
        selectValues: 'Select value(s) for',
        selectAll: 'Select all',
        selectAllFiltered: 'Select all search results',
        noAttributeFoundSnapshot:
          'There are no attributes for selected snapshot.',
        noAttributeFoundFilter:
          'There are no attributes for selected search query.',
        noValueFoundSnapshot:
          'There are no values for this attribute for selected snapshot.',
        noValueFoundFilter:
          'There are no values for this attribute for selected search query.',
      },
      scrollPaginator: {
        error: 'Failed to fetch items',
      },
      selectSnapshot: {
        placeholder: 'Select a snapshot',
        placeholderNoSnapshots: 'No snapshot available',
      },
      snapshotsList: {
        snapshotWithoutName: 'Snapshot',
      },
      fileUploader: {
        extError: 'The file cannot be uploaded. Use only following formats: ',
        sizeError: 'The file exceeds the maximum size: ',
        extSeparator: ' or ',
        or: 'or',
        DnDyourFileHere: 'Drag & Drop your file here',
        browseFile: 'Browse File',
        filePreview: {
          delete: 'Delete',
          uploading: 'Uploading',
        },
        confirmDialog: {
          header: 'The file has already been uploaded',
          subHeader: 'Do you want to replace {fileName}?',
          btnConfirm: 'Replace',
          btnSecondaryConfirm: 'Cancel',
        },
      },
    },
    tableDeletionHelper: {
      deleteConfirmDialog: {
        header: '{count, plural, one {Item} other {# Items}} will be deleted',
        subHeader: 'Delete {count, plural, one {item} other {# items}}?',
        btnConfirm: 'Delete',
        btnSecondaryConfirm: 'Cancel',
      },
    },
  },
};
